
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'OxdOverlay',

  props: {
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    centered: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-overlay': true,
        'oxd-overlay--flex': true,
        'oxd-overlay--flex-centered': this.centered,
        'oxd-overlay--hide': !this.show,
      };
    },
  },
});
